module.exports = __webpack_public_path__ + "static/flow-c1f6ae8fc53e6600038bdecd58618e89.svg";